import { render, staticRenderFns } from "./route-list-citys-data.vue?vue&type=template&id=3f607004&"
import script from "./route-list-citys-data.vue?vue&type=script&lang=ts&"
export * from "./route-list-citys-data.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports